// Países con norma disponible (ver spec del cliente, sección "Normas por
// país"). Compartido entre Explorar (selección) y Ejecutar (banner de norma
// resuelta), para que el país elegido viaje de una pantalla a la otra.
export const NORM_COUNTRIES = [
  { value: "AR", text: "Argentina" },
  { value: "MX", text: "México" },
  { value: "BR", text: "Brasil" },
  { value: "CL", text: "Chile" },
  { value: "CO", text: "Colombia" },
  { value: "PE", text: "Perú" },
];
